// images
import blogImg1 from "../images/blog/3.jpg";
import blogImg2 from "../images/blog/2.png";
import blogImg3 from "../images/blog/4.webp";
import blogImg4 from "../images/blog/5.png";
import blogImg5 from "../images/blog/da-img05.jpg";
import blogImg6 from "../images/blog/da-img06.jpg";
import blogImg7 from "../images/blog/img01.jpg";
import blogImg8 from "../images/blog/img02.jpg";
import blogImg9 from "../images/blog/img03.jpg";
import blogImg10 from "../images/blog/cd-img01.jpg";
import blogImg11 from "../images/blog/cd-img02.jpg";
import blogImg12 from "../images/blog/cd-img03.jpg";
import blogImg13 from "../images/blog/img04.jpg";
import blogImg14 from "../images/blog/img05.jpg";
import blogImg15 from "../images/blog/img06.jpg";
import blogImg16 from "../images/blog/img07.jpg";



const blogs = [
    {
        id: '1',
        title: 'AI in Neuroimaging: IXICO’s Cloud Transformation',
        slug:'AI-in-Neuroimaging-IXICOs-Cloud-Transformation',
        screens: blogImg1,
        description: 'Embark on an enlightening journey through the realm.',
        author: 'farugia',
        authorTitle:'Sineor Consultant',
        create_at: 'October 4, 2022',
        comment:'35',
        thumb:'Technology',
        blClass:'format-standard-image',
    },
    {
        id: '2',
        title: 'Cutting Clinical Trial Costs with AI Biomarkers',
        slug:'Cutting-Clinical-Trial-Costs-with-AI-Biomarkers',
        screens: blogImg2,
        description: 'To perform a comprehensive SEO audit, check...',
        author: 'Andrew',
        authorTitle:'Creative Director',
        create_at: 'October 4, 2023',
        comment:'80',
        thumb:'Branding',
        blClass:'format-standard-image',
    },
    {
        id: '3',
        title: 'Scaling Medical Imaging with Microsoft Cloud',
        slug: 'Scaling-Medical-Imaging-with-Microsoft-Cloud',
        screens: blogImg3,
        description: 'SEO audits are crucial for maintaining your websites.',
        author: 'Kurtz',
        authorTitle:'Art Director',
        create_at: 'October 4, 2024',
        comment:'95',
        thumb:'SEO',
        blClass:'format-video',
    },
    {
        id: '4',
        title: 'Faster Neuro Trials with AI-Powered Imaging',
        slug: 'Faster-Neuro-Trials-with-AI-Powered-Imaging',
        screens: blogImg4,
        description: 'Digital transformation with IT solutions is about using.',
        author: 'Alex',
        authorTitle:'Art Director',
        create_at: 'October 5, 2023',
        comment:'95',
        thumb:'Branding',
    }

  
  
];
export default blogs;